(ns frontend.view.kpi-reporting.kpi-categories.view
  (:require
   [reagent.core :as r]
   [ui.util :as uu]
   [clojure.string :as string]
   [common.localization :as loc]
   [common.util :as cu :refer [flip]]
   [common.features.plan :as plan]
   [frontend.routing :as routing]
   [frontend.utils :as fu]
   [frontend.view.syncing-data :as sync]
   [frontend.view.not-found :as not-found]
   [frontend.view.kpi-reporting.kpi-categories.db :as db]
   [frontend.view.kpi-reporting.kpi-categories.events :as events]
   [frontend.view.kpi-reporting.kpi-categories.settings-events :as settings-events]
   [frontend.view.kpi-reporting.kpi-offer.view :as kpi-offer]
   [potpuri.core :refer [fn-> fn->> index-by deep-merge]]
   [frontend.view.modals.new-kpi-cycle.view :as new-kpi-cycle]
   [frontend.view.modals.new-kpi-report.view :as new-kpi-report]
   [frontend.view.modals.events :as modals]
   [frontend.view.kpi-reporting.kpi-categories.wizard :as wizard]
   [frontend.view.kpi-reporting.kpi-categories.creator :as creator]
   [frontend.view.kpi-reporting.kpi-categories.settings :as settings]
   [frontend.bootstrap.components :as rbs]
   [frontend.page-components.zap-toolbar :as zap-toolbar]
   [frontend.state.current-session :as session]
   [common.sync-progress :as sync-progress]
   [ui.components.radix-ui.dropdown-menu.view :as dropdown-menu]
   [frontend.page-components.default-page-layout :as default-page-layout]
   [ui.components.button.view :as button]
   [ui.editors.data-input :as data-input]))

;;empty for now - might change later
(defn navigation-elems
  [state]
  nil
  #_(loc/tr :kpi-reports/sub-navbar-heading))

(defn settings-nav
  [state]
  (let [category (events/selected-category)
        name (:kpi-category/name category)]
    [:span
     [button/secondary-open
      {:class-name (fu/cs "zap-btn__hollow__green kpi-category-settings-back-button")
       :on-click   #(events/exit-settings!)}
      "< " (loc/tr :back)]]))

(defn report-cell
  [{:keys [member company report cycle category]}]
  (let [status (:kpi-report/status report)
        open-report! (fn [_]
                       (routing/set-view! [:kpi-company-reports :id (:db/id company)]
                                          {:report report}))]
    (cond

      (= status :kpi-report.status/wip)
      [:span.report-indicator.wip.clickable
       {:on-click open-report!}
       [:span.report-dot]] ;;a yellow sphere
      (= status :kpi-report.status/submitted)
      [:span.report-indicator.submitted.clickable
       {:on-click open-report!}
       [:span.report-dot]] ;;an empty sphere with green border
      (= status :kpi-report.status/reviewed)
      [:span.report-indicator.reviewed.clickable
       {:on-click open-report!}
       [:span.report-dot]] ;;a green sphere
      ;; no report:
      (nil? report)

      [button/square-secondary-open
       {:tooltip (loc/tr :get-from-this-company)
        :on-click (fn [_]
                    ;;create a report for this company in this cycle
                    (modals/open-modal!
                     new-kpi-report/modal-key
                     {:cycle    cycle
                      :member   member
                      :category category
                      :company  company}))}
       [:i.fal.fa-plus]])))

(defn their-contact-disabled?
  [active-guest-role-entities kpi-member company contact-account-entity]
  (let [company-id (:db/id company)
        company-roles (->> active-guest-role-entities
                           (cu/filter-by :role/target company-id)
                           (map :role/subject)
                           set)]
    (not (and contact-account-entity
              (not (:common/disabled? contact-account-entity))
              (contains? company-roles (:db/id contact-account-entity))))))

(defn category-view
  [category]
  (let [name (:kpi-category/name category)
        category-id (:db/id category)
        entities @session/entities
        category-members
        (->> @session/all-kpi-members
             (cu/only-entity :kpi-member/target category-id)
             (remove :common/disabled?)
             (sort-by (fn->> :kpi-member/asset (get entities) :asset/name str string/lower-case)))
        no-members? (empty? category-members)
        all-cycles (->> @session/all-kpi-cycles
                        (cu/only-entity :kpi-cycle/kpi-category category-id)
                        (remove :common/disabled?)
                        (sort-by (juxt :kpi-cycle/target-year :kpi-cycle/target-month)))
        minimized? (and (> (count all-cycles) 3)
                        (not (:expanded? @db/state)))
        cycles (if minimized?
                 (take-last 3 all-cycles)
                 all-cycles)
        cycle-ids (->> cycles
                       (map :db/id)
                       set)
        active-guest-roles (->> @session/all-roles
                                (remove :common/disabled?)
                                (filter (fn [r]
                                          (some #{(:role/role r)}
                                                [:role/guest-buy-side :role/guest-sell-side]))))
        kpi-reports @session/all-kpi-reports]
    [:div
     {:class "flex-1 overflow-auto"}
     [:div.d-inline-flex.flex-column.w-100.px-3
      [:div
       [:div.kpi-legends
        [:span.report-indicator.kpi-legend.wip
         [:span.report-dot] " " (loc/tr :kpi-report.status/wip)]
        [:span.report-indicator.kpi-legend.submitted
         [:span.report-dot] " " (loc/tr :kpi-report.status/submitted)]
        [:span.report-indicator.kpi-legend.reviewed
         [:span.report-dot] " " (loc/tr :kpi-report.status/reviewed)]]]
      [:div.kpi-reports-table-wrapper
       [:div.table-aside
        [rbs/Table {:class-name "zapflow-table kpi-category-table"}
         [:thead
          [:tr
           [:th
            {:class-name (when no-members?
                           "no-members")}
            (if (empty? category-members)
              (loc/tr :no-companies)
              (loc/tr :company))]]]

         [:tbody
          (doall
           (for [category-member category-members
                 :let [company-id (->> category-member
                                       :kpi-member/asset)
                       company (get entities company-id)
                       member-id (:db/id category-member)
                       company-reports? (->> kpi-reports
                                             (cu/only-entity :kpi-report/company company-id)
                                             (remove :common/disabled?)
                                             (filter (fn [r]
                                                       (let [report-cycle (:kpi-report/kpi-cycle r)]
                                                         (contains? cycle-ids report-cycle))))
                                             empty?
                                             not)
                       their-contact (->> (:kpi-member/account category-member)
                                          (get entities))
                       disabled-contact? (their-contact-disabled? active-guest-roles
                                                                  category-member
                                                                  company
                                                                  their-contact)
                       status (:kpi-member/status category-member)
                       paused? (= status :kpi-member.status/paused)]]
             ^{:key (str "category-member-" (:db/id category-member))}
             [:tr
              [:td.kpi-member-company-cell
               [:div.d-flex.align-items-center
                (when paused?
                  [button/square-secondary-open
                   {:tooltip (loc/tr :kpi-category/member-paused-tooltip)}
                   [:i.fal.fa-pause.mr-2]])

                [:span.kpi-member-company-name
                 {:on-click (fn [_]
                              (events/open-company-reports! company category))}
                 (:asset/name company)]
                (when disabled-contact?
                  [button/square-secondary-open
                   {:tooltip (loc/tr :kpi-category/contact-disabled-tooltip)}
                   [:i.fal.fa-exclamation-circle.kpi-contact-disabled.ml-2]])]]]))
          [:tr
           [:td.kpi-member-company-cell
            #_[button/secondary-open
               {:variant    "link"
                :on-click   (fn [_]
                              (events/start-add-company! category category-members))}
               [:i.fal.fa-plus] [:span (loc/tr :kpi-category/add-company)]]]]]]]
       [:div.d-inline-flex.table-content-wrapper
        (if (empty? cycles)
          [:h3 (loc/tr :no-reporting-cycles-found)]
          [:div
           [rbs/Table {:class-name "zapflow-table kpi-category-table"}
            [:thead
             [:tr
              (when minimized?
                [:th.clickable
                 {:key      (str "cycle-head-expand")
                  :style    {:min-width     "10px"
                             :padding-left  "0"
                             :padding-right "0"}
                  :on-click (fn [_]
                              (swap! db/state assoc :expanded? true))}
                 [:span
                  [:i.fas.fa-chevron-double-left]]])
              (doall (for [cycle cycles
                           :let [cycle-id (:db/id cycle)
                                 target-year (:kpi-cycle/target-year cycle)
                                 target-month (:kpi-cycle/target-month cycle)]]
                       ^{:key (str "cycle-head-" cycle-id)}
                       [:th (str target-year "/" target-month)]))]]
            [:tbody
             (doall
              (for [category-member category-members
                    :let [company-id (->> category-member
                                          :kpi-member/asset)
                          company (get entities company-id)
                          status (:kpi-member/status category-member)
                          paused? (= status :kpi-member.status/paused)
                          company-id (:db/id company)]]
                ^{:key (str "category-member-" company-id)}
                [:tr
                 {:class-name (fu/cs "kpi-member-row"
                                     (when paused?
                                       "paused"))}
                 (when minimized?
                   [:td.kpi-report-cell.cell-gradient
                    {:key (str "cycle-" company-id "-minimized")}])
                 (for [cycle cycles
                       :let [cycle-id (:db/id cycle)
                             report (->> kpi-reports
                                         (cu/only-entity :kpi-report/kpi-cycle cycle-id)
                                         (cu/only-entity :kpi-report/company company-id)
                                         (remove :common/disabled?)
                                         (first))]]
                   ^{:key (str "cycle-" company-id "-" cycle-id)}
                   [:td.kpi-report-cell
                    [report-cell
                     {:report   report
                      :company  company
                      :member   category-member
                      :category category
                      :cycle    cycle}]])]))
             [:tr.kpi-member-row
              (when minimized?
                [:td.kpi-report-cell
                 {:key (str "remove-cell-minimized")}
                 ""])
              (->> cycles
                   (map (fn [cycle]
                          (let [cycle-id (:db/id cycle)
                                reports? (->> kpi-reports
                                              (cu/only-entity :kpi-report/kpi-cycle cycle-id)
                                              (remove :common/disabled?)
                                              empty?
                                              not)]
                            ^{:key (str "remove-cell-" cycle-id)}
                            [:td
                             {:class-name (fu/cs "kpi-report-cell")}
                             (if reports?
                               [:span ""]
                               [:span.report-indicator.clickable
                                {:on-click (partial events/start-remove-cycle! cycle-id)}
                                [:i.fal.fa-trash-alt]])])))
                   (doall))]]]])]]]]))

(defn cycle-downloader
  [category]
  (let [category-id (:db/id category)
        cycles (->> @session/all-kpi-cycles
                    (cu/only-entity :kpi-cycle/kpi-category category-id)
                    (remove :common/disabled?)
                    (remove events/empty-cycle?)
                    (sort-by (juxt :kpi-cycle/target-year :kpi-cycle/target-month)))]
    (when-not (empty? cycles)
      [:div
       [dropdown-menu/view
        {:trigger [dropdown-menu/button-trigger-hollow
                   (loc/tr :download-cycle)]
         :items   (->> cycles
                       (mapv (fn [{:keys [db/id kpi-cycle/target-year kpi-cycle/target-month] :as cycle}]
                               {:value [:div
                                        {:key       (str "download-cycle-" id)
                                         :id        id
                                         :on-click (fn [e]
                                                     (events/export-cycle cycle))}
                                        [:span (str target-year "/" target-month)]]
                                :custom-item? true}))
                       (doall))}]])))

(defn custom-toolbar-components
  [selected-category categories]
  [:div.kpi-custom-toolbar-container.d-flex.justify-content-between
   [:div.toolbar-categories
    ;;Category listing:
    [:div
     {:class "min-w-56"}
     [data-input/view
      {:editor-type   :editor.type/select
       :data-type     :data.type/ref-single
       :is-clearable? false
       :full-width?   true
       :value         (:db/id selected-category)
       :options       (concat (->> categories
                                   (map (fn [c]
                                          {:value (:db/id c)
                                           :label (:kpi-category/name c)})))
                              (when (session/is-admin?)
                                [{:value 0
                                  :label (loc/tr :add-new-category)}]))
       :on-change     (fn [new-value & _]
                        (cond
                          (nil? new-value) nil
                          (zero? new-value) (events/start-creator!)
                          :else (events/select-category! new-value)))}]]]
   [cycle-downloader selected-category]])

(defn settings-button
  [category]
  {:toolbar-button? false
   :dropdown-action? true
   :ord 15
   :primary-button? false
   :on-select #(events/open-settings!)
   :label (loc/tr :settings)})

(defn add-company-button
  [category members]
  {:toolbar-button? true
   :dropdown-action? false
   :ord 13
   :primary-button? true
   :on-select (fn [_]
                (events/start-add-company! category members))
   :label (loc/tr :kpi-category/add-company)})

(defn add-cycle-button
  [category]
  {:toolbar-button? true
   :dropdown-action? false
   :ord 10
   :primary-button? true
   :on-select #(modals/open-modal!
                new-kpi-cycle/modal-key
                {:category category})
   :label (loc/tr :initialize-new-cycle)})

(defn abort-button
  [category]
  {:toolbar-button? true
   :dropdown-action? false
   :ord       15
   :icon      :fa-trash
   :primary-button? false
   :on-select #(events/abort-category! category)
   :label     (loc/tr :abort)})

(defn toolbar-actions
  []
  (let [category (events/selected-category)
        category-id (:db/id category)
        category-members (->> @session/all-kpi-members
                              (cu/only-entity :kpi-member/target category-id)
                              (remove :common/disabled?))]
    (when-not (session/is-read-only-user?)
      [(settings-button category)
       (add-company-button category category-members)
       (add-cycle-button category)])))

(defn creator-toolbar-actions
  []
  (let [wip-category (events/get-wip-category)]
    [(abort-button wip-category)]))

(defn settings-toolbar-actions
  []
  (let [kpi-template-settings? (->> @db/settings-state
                                    :active-key
                                    (= "report-template"))
        kpi-category (events/selected-category)]
    [(when kpi-template-settings?
       {:toolbar-button? true
        :dropdown-action? false
        :ord 14
        ;;:icon             :fa-trash
        :primary-button? false
        :on-select #(settings-events/open-kpi-curtain! :quantitative kpi-category)
        :label (loc/tr :add-metrics)})
     (when kpi-template-settings?
       {:toolbar-button? true
        :dropdown-action? false
        :ord 12
        ;;:icon             :fa-trash
        :primary-button? false
        :on-select #(settings-events/open-kpi-curtain! :qualitative kpi-category)
        :label (loc/tr :add-questions)})]))

(defn wizard-toolbar-actions
  []
  (let [wip-category (events/get-wip-category)]
    [{:primary-button? true
      :label (loc/tr :kpi-wizard/schedule-human-assisted-setup)
      :toolbar-button? true
      :dropdown-action? false
      :ord 10
      :on-select (fn [e]
                   ;;(analytics/event "Schedule-category-setup") ;;TODO should we add something like this?
                   (.. js/window (open "https://app.hubspot.com/meetings/karri-makitalo")))}
     (when (:video-seen? @db/wizard-state)
       {:primary-button? false
        :label (loc/tr :watch-tutorial-video)
        :toolbar-button? true
        :dropdown-action? false
        :ord 11
        :on-select (fn [e]
                     (swap! db/wizard-state assoc
                            :info-seen? true
                            :video-seen? false
                            :kpis-selected? false
                            :email-template-finished? false
                            :companies-added? false
                            :category-name-finished? false
                            :cycle-details-finished? false))})
     (when (:info-seen? @db/wizard-state)
       (abort-button wip-category))]))

(defn turn-on-view
  []
  [:div.kpi-turn-on
   (loc/tr :kpi-turn-on)])

(defn get-started-view
  []
  [:div.kpi-get-started
   [:div.kpi-get-started-info
    (loc/tr :kpi-category/get-started-info)]
   [button/primary-solid
    {:on-click   events/start-creator!}
    (loc/tr :kpi-category/get-started)]])

(defn ad-view
  []
  (r/create-class
   {:component-did-mount
    (fn [_]
      (events/view-ad!))
    :reagent-render
    (fn [_]
      [kpi-offer/view])}))

(defn view
  []
  (let [categories (->> @session/all-kpi-categories
                        (remove :common/disabled?)
                        (filter (fn-> :kpi-category/status (= :kpi-category.status/finished)))
                        (sort-by :common/created-on))
        show-ad? (not (plan/available :feature/kpi-reporting @session/tenant @session/role))
        ;;no categories & normal user:
        show-turn-on? (and (empty? categories)
                           (= @session/role :role/user))
        wizard-finished? (-> @session/tenant
                             :tenant/kpi-category-wizard-status
                             (= :wizard-finished))

        creator? (:show? @db/creator-state)
        show-get-started? (and wizard-finished?
                               (not creator?)
                               (empty? categories))
        ;;no categories & admin:
        show-wizard? (empty? categories)
        not-configured? (and (empty? categories)
                             (not wizard-finished?))
        settings? (:show? @db/settings-state)
        selected (events/selected-category)
        _ (when (and (or (nil? selected)
                         (:common/disabled? selected)
                         (-> selected
                             :kpi-category/status
                             (= :kpi-category.status/finished)
                             not))
                     (not (empty? categories)))
            (events/select-category! (:db/id (first categories))))
        selected-category (events/selected-category)
        hiccup [:<>
                (cond
                  show-ad?
                  nil
                  show-turn-on?
                  nil
                  (and (session/sys-admin?) show-wizard?)
                  [zap-toolbar/view db/state navigation-elems nil (wizard-toolbar-actions) nil]
                  show-get-started?
                  nil
                  not-configured?
                  nil
                  creator?
                  [zap-toolbar/view db/state navigation-elems nil (creator-toolbar-actions) nil]
                  settings?
                  [zap-toolbar/view db/state settings-nav nil (settings-toolbar-actions) nil]
                  :else
                  [zap-toolbar/view db/state navigation-elems nil (toolbar-actions)
                   (partial custom-toolbar-components
                            selected-category
                            categories)])
                (cond
                  show-ad?
                  [ad-view]
                  show-turn-on?
                  [turn-on-view]
                  show-wizard?
                  [wizard/view]
                  show-get-started?
                  [get-started-view]
                  not-configured?
                  [wizard/not-configured-view]
                  creator?
                  [creator/view]
                  settings?
                  [settings/view selected-category]
                  :else
                  [:div
                   [category-view selected-category]])]]
    hiccup))

(defmethod routing/render-view :kpi-categories
  [_]
  (let [kpi-feature? (plan/available :feature/kpi-reporting @session/tenant @session/role)
        sys-admin? (session/sys-admin?)
        kpi-module? (session/kpi-reporting?)]
    [default-page-layout/view
     {:class-name "zap-page kpi-summary"}
     [sync/wait-until-sync-progress sync-progress/KPI-DATA
      (if (and kpi-feature?
               (not sys-admin?)
               (not kpi-module?))
        [not-found/not-found-content]
        [view])]]))
